import request from '@/router/axios';

export function getProjectListpage(obj) {
    return request({
        url: '/project/page',
        method: 'POST',
        data: obj,
    });
}

/**
 *  获取动态表单回显值
 */
export function getDynamicFormValue(projectId) {
    return request({
        url: '/project/getProjectInfo/'+projectId,
        method: 'GET',
    });
}
/**
 *  查询项目信息
 */
export function getProjectInfo() {
    return request({
        url: '/project/getProjectInfo',
        method: 'GET',
    });
}

/**
 *  根据id修改数据
 * @param obj
 */
export function updateListpage(obj) {
    return request({
        url: '/project/update',
        method: 'put',
        data: obj,
    });
}

export function addListpage(obj) {
    return request({
        url: '/project/add',
        method: 'post',
        data: obj,
    });
}
export function batchUpdateStatus(obj) {
    return request({
        url: '/project/batchUpdate',
        method: 'post',
        data: obj,
    });
}
/**
 *  获取项目管理员信息
 */
export function getProjectAdminInfo(id) {
    return request({
        url: '/project/getProjectAdminInfo/'+id,
        method: 'GET',
    });
}
//添加项目管理员
export function addProjectAdminInfo(obj) {
    return request({
        url: '/project/addAdmin',
        method: 'post',
        data: obj,
    });
}
//加载项目列表，用于下拉搜索
export function loadProjectList() {
    return request({
        url: '/project/loadProjectList',
        method: 'GET',
    });
}


